import { logger } from "../core/logger";
import { THEME_EVENTS, subscribe } from "../../shared/events";

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.buttons = this.querySelectorAll("button");

    this.changeEvent = new Event("change", { bubbles: true });

    this.isLocked = false;

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.buttons.forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  connectedCallback() {
    this.unsubscribeCart = subscribe(
      THEME_EVENTS.cartUpdate,
      this.handleCartUpdate.bind(this),
    );

    logger.debug("QuantityInput", "connected");
  }

  disconnectedCallback() {
    if (this.unsubscribeCart) {
      this.unsubscribeCart();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    if (this.isLocked) return;
    event.preventDefault();

    const previousValue = this.input.value;

    if (event.currentTarget.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      // ✅ On lock UNIQUEMENT si on est dans le cart
      if (this.dataset.key) {
        this.lock();
      }
    }
  }

  lock() {
    this.isLocked = true;

    this.buttons.forEach((btn) => {
      btn.disabled = true;
      btn.classList.add("loading");
    });
  }

  unlock() {
    this.isLocked = false;

    this.buttons.forEach((btn) => {
      btn.disabled = false;
      btn.classList.remove("loading");
    });
  }

  handleCartUpdate(event) {
    // On ne débloque que quand la mutation cart est terminée
    if (event.source === "cart-items") {
      this.unlock();
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (this.input.min) {
      const buttonMinus = this.querySelector("[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        value <= parseInt(this.input.min),
      );
    }

    if (this.input.max) {
      const buttonPlus = this.querySelector("[name='plus']");
      buttonPlus.classList.toggle(
        "disabled",
        value >= parseInt(this.input.max),
      );
    }
  }
}

if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}
